'use client';

import { c as _c } from "react/compiler-runtime";
import type { GlobeMode } from '@morfi/globe';
import dynamic from 'next/dynamic';
import { useSearchParams } from 'next/navigation';
import { type ComponentType, type ReactElement, Suspense, useEffect } from 'react';
import { useFeatureGate } from '@/hooks/use-feature-gate';
import { useGlobeStore } from '@/stores/globe';

// The overlay (and the cobe WebGL bundle) only loads once the globe is opened.
const GlobeOverlay: ComponentType = dynamic(() => import('./globe-overlay').then(m => m.GlobeOverlay), {
  ssr: false
});
const MODES: ReadonlySet<string> = new Set<string>(['market', 'launch', 'winner', 'users']);
export function GlobeMount() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={null}><GlobeMountInner /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function GlobeMountInner() {
  const $ = _c(6);
  const open = useGlobeStore(_temp);
  const openGlobe = useGlobeStore(_temp2);
  const params = useSearchParams();
  const globeEnabled = useFeatureGate("region");
  let t0;
  let t1;
  if ($[0] !== globeEnabled || $[1] !== openGlobe || $[2] !== params) {
    t0 = () => {
      const g = params.get("globe");
      if (!g) {
        return;
      }
      if (globeEnabled === null) {
        return;
      }
      if (MODES.has(g) && globeEnabled) {
        openGlobe(g as GlobeMode);
      }
      const next = new URLSearchParams(params);
      next.delete("globe");
      const qs = next.toString();
      window.history.replaceState(null, "", `${window.location.pathname}${qs ? `?${qs}` : ""}`);
    };
    t1 = [params, openGlobe, globeEnabled];
    $[0] = globeEnabled;
    $[1] = openGlobe;
    $[2] = params;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  if (!open || globeEnabled !== true) {
    return null;
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <GlobeOverlay />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
function _temp2(s_0) {
  return s_0.openGlobe;
}
function _temp(s) {
  return s.open;
}